import { PageHero } from "../components/PageHero";
import { Reveal, SectionLabel } from "../components/Motion";
import { Star } from "../components/brand/Logo";
import { CtaBand } from "../components/CtaBand";
import { useLang } from "../i18n/LangContext";

const STATUE = "https://images.unsplash.com/photo-1670813885725-e3c5391dcd31?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export default function Studio() {
  const { t } = useLang();
  return (
    <>
      <PageHero testid="studio-hero" label={t.studio.label} lines={t.studio.title} accentLine={3} />
      <section className="mx-auto grid max-w-[1440px] gap-14 px-5 pb-28 md:px-10 lg:grid-cols-12">
        <Reveal className="relative lg:col-span-6">
          <div className="relative aspect-[4/5] overflow-hidden rounded-sm">
            <img src={STATUE} alt={t.a11y.statue} className="h-full w-full object-cover grayscale brightness-150 contrast-110" />
            <div className="absolute inset-0 bg-lav mix-blend-multiply opacity-50" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/50 via-transparent to-transparent" />
            <Star className="absolute bottom-8 right-8 h-14 w-14 text-ivory" />
          </div>
        </Reveal>
        <div className="flex flex-col justify-center lg:col-span-5 lg:col-start-8">
          <Reveal>
            <p className="font-display text-2xl font-light leading-snug text-ivory md:text-3xl" data-testid="studio-body">{t.studio.body}</p>
            <p className="mt-8 leading-relaxed text-mist">{t.studio.body2}</p>
            <p className="label mt-8 text-lav">{t.common.remote}</p>
          </Reveal>
        </div>
      </section>
      <section className="bg-ivory py-28 text-ink" data-testid="studio-reasons">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
          <SectionLabel tone="text-ink/60">{t.why.label}</SectionLabel>
          <div className="mt-14 divide-y divide-ink/10 border-y border-ink/10">
            {t.why.items.map(([title, body], i) => (
              <Reveal key={title} delay={i * 0.05}>
                <div className="grid gap-4 py-10 md:grid-cols-12 md:items-baseline">
                  <span className="label text-lav-deep md:col-span-1">0{i + 1}</span>
                  <h3 className="font-display text-3xl font-bold uppercase leading-none tracking-tight md:col-span-6 md:text-5xl">{title}</h3>
                  <p className="text-ink/65 md:col-span-4 md:col-start-9">{body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <section className="mx-auto max-w-[1440px] px-5 py-28 md:px-10" data-testid="studio-process">
        <SectionLabel>{t.studio.processLabel}</SectionLabel>
        <div className="mt-14 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {t.studio.process.map(([title, body], i) => (
            <Reveal key={title} delay={i * 0.08} className="bg-ink">
              <div className="group h-full p-8">
                <span className="font-display text-7xl font-extrabold text-stroke transition-colors duration-500 group-hover:text-lav">0{i + 1}</span>
                <h3 className="mt-8 font-display text-2xl font-bold uppercase tracking-tight text-ivory">{title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-mist">{body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CtaBand />
    </>
  );
}
